(function ($, _) {
    'use strict';

    const dataAttributes = {
        containerSelector: 'umw-tab-container',
        tabName: 'umw-tab-name',
        tabClass: 'umw-tab-class',
        position: 'umw-tab-position'
    };

    const $umwTabsContainers = $('.js-umw-tabs-check-if-empty');

    $(function () {
        var selectorsMap = {}, tabContainerMap = {};
        $('[data-' + dataAttributes.containerSelector + ']').each(function () {
            var $content = $(this);
            $content.find('script').remove(); // Clear scripts inside the moving nodes in order to prevent double-executing

            var hasContent = $.trim($content.text()).length > 0 || $content.find('iframe').length > 0 || $content.find('img').length > 0;
            if (hasContent) {
                var containerSelector = $content.data(dataAttributes.containerSelector);

                var $tabsContainer;
                if (selectorsMap[containerSelector]) {
                    $tabsContainer = selectorsMap[containerSelector];
                } else {
                    // Multiple elements can be found by a single selector. We can not clone content to every found tabs container because scripts of cloned content will become broken.
                    // Therefore, always use the first found element as a single tabs container
                    $tabsContainer = selectorsMap[containerSelector] = $(containerSelector).first();
                }

                if (!$tabsContainer.length) {
                    console.error('[UMW]: Tab builder - Cannot find tabs container by "' + containerSelector + '" selector');
                    return;
                }

                // Get or define unique tab container id attribute
                var tabContUniqueId = $tabsContainer.attr('id');
                if (!tabContUniqueId) {
                    $tabsContainer.attr('id', tabContUniqueId = _.uniqueId('tabCont'));
                }

                // The same tabs container can be found by different selector. Merge if the same container was already found by different selector
                if (!tabContainerMap[tabContUniqueId]) {
                    tabContainerMap[tabContUniqueId] = [];
                }

                var tabDetails = {
                    $content: $content,
                    tabName: _getTabTitle($content),
                    position: $content.data(dataAttributes.position),
                    containerId: _getTabContainerId($content),
                    tabClass: $content.data(dataAttributes.tabClass)
                }

                tabContainerMap[tabContUniqueId].push(tabDetails);
            }
        });

        if (!_.isEmpty(tabContainerMap)) {

            // Check URL for speific parameter "tab", to preselect tab at build
            const searchParams = new URLSearchParams(window.location.search);
            let urlPreselectedTabName = null;

            for (let param of searchParams) {
                if (param[0] === "tab") {
                    urlPreselectedTabName = param[1].toLowerCase();
                    break;
                }
            }

            _.each(tabContainerMap, function (tabDetailsList, containerUniqueId) {
                var $tabsContainer = $('#' + containerUniqueId);
                var hasActiveTabs = false;
                var sourceContainerIds = [];
                var overrideActiveState = false;

                var $navTabs = $tabsContainer.find('.nav-tabs');
                if ($navTabs.length > 0) {
                    $navTabs.detach();

                    hasActiveTabs = $navTabs.find('.active').length > 0;
                } else {
                    $navTabs = _$createElem('ul', 'nav nav-tabs', { 'role': 'tablist' });
                }

                var $tabPanes = $tabsContainer.find('.tab-content');
                if ($tabPanes.length > 0) {
                    $tabPanes.detach();
                } else {
                    $tabPanes = _$createElem('div', 'tab-content');
                }

                var sorted = _.sortBy(tabDetailsList, 'position');
                var grouped = _.groupBy(sorted, 'tabName');

                // Add all source containers IDs to array to compare with Url seach param
                if (urlPreselectedTabName) {
                    _.each(grouped, function (contentParts) {
                        sourceContainerIds.push(contentParts[0].containerId);
                    });
                    overrideActiveState = _.indexOf(sourceContainerIds, urlPreselectedTabName) > 0 ? true : false;
                }

                _.each(grouped, function (contentParts, tabName) {
                    var tabId = _.uniqueId(containerUniqueId + '_tab');
                    var isActiveTab = !hasActiveTabs && (hasActiveTabs = true); // Set tab as active if there are no active tabs yet
                    if (overrideActiveState) { // Override selected tab if selected tab parameter for selected tab passet by URL
                        isActiveTab = false;
                        if (urlPreselectedTabName === contentParts[0].containerId) {
                            isActiveTab = true;
                        }
                    }

                    // Nav tab
                    if ($("body").hasClass("bs5")) {
                        const $tabNavAnchor = _$createElem('button', isActiveTab ? 'nav-link active' : 'nav-link', { 'type': 'button', 'id': tabId + '-tab', 'data-bs-toggle': 'pill', 'data-bs-target': '#' + tabId, 'role': 'tab', 'aria-controls': tabId, 'aria-selected': 'false' }, tabName);
                        const liClass = 'nav-item' + (contentParts[0] && contentParts[0].tabClass ? ' ' + contentParts[0].tabClass : '');
                        _$createElem('li', liClass, { 'role': 'presentation' }).append($tabNavAnchor).appendTo($navTabs);
                    } else {
                        const $tabNavAnchor = _$createElem('a', null, { 'href': '#' + tabId, 'aria-controls': tabId, 'role': 'tab', 'data-toggle': 'tab' }, tabName);
                        const liClass = ((isActiveTab ? 'active' : '') + (contentParts[0] && contentParts[0].tabClass ? ' ' + contentParts[0].tabClass : '')).trim();
                        _$createElem('li', liClass, { 'role': 'presentation' }).append($tabNavAnchor).appendTo($navTabs);
                    }

                    // Tab pane
                    const tabClass = 'tab-pane ' + ((isActiveTab ? ' active' : '') + (contentParts[0] && contentParts[0].tabClass ? ' ' + contentParts[0].tabClass : '')).trim();
                    var $tabPane = _$createElem('div', tabClass, { 'id': tabId, 'role': 'tabpanel' }).appendTo($tabPanes);
                    _.each(contentParts, function (part) {
                        // Prepare the content
                        part.$content.detach();
                        part.$content.removeClass('hidden').show(); // Make the content visible in case it is hidden

                        part.$content.appendTo($tabPane);
                    });
                });

                $tabsContainer.append($navTabs, $tabPanes);

                $tabsContainer.show();
            });
        } else {
            // Markup trash collector, if empty container exists. 
            // In case specific control builds the tabs but can't check content model of related to him controls at the same page, which participates in tab building process.            
            $umwTabsContainers.each(function () {
                var $this = $(this);
                if ($this.text().length === 0) $this.remove();
            });
        }
    });

    function _$createElem(tag, className, attributes, textContent) {
        var elem = document.createElement(tag);

        if (className) {
            elem.className = className;
        }

        if (attributes) {
            _.each(attributes, function (attrValue, attrName) {
                elem.setAttribute(attrName, attrValue);
            });
        }

        if (textContent) {
            elem.textContent = textContent;
        }

        return $(elem);
    }

    function _getTabTitle($tabContent) {
        var tabTitle = $tabContent.data(dataAttributes.tabName); // Preferred way
        if (!tabTitle) {
            tabTitle = $tabContent.prevAll('input:hidden.TabTitle').val() ||
                $tabContent.find('.js-tab-name,.Title,.MainTitle').first().text() ||
                _.uniqueId('Tab ');
        }

        return tabTitle;
    }

    function _getTabContainerId($tabContent) {
        var tabContainerId = $tabContent.attr('id');
        if (tabContainerId) {
            tabContainerId = tabContainerId.toLowerCase();
        }
        return tabContainerId;
    }
})(jQuery, _);